var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDream3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1578 54.7949C33.1578 54.7949 8.78125 41.2184 8.78125 24.9264C8.78125 8.63437 27.7408 7.27671 33.1578 20.0236C38.5749 7.27671 57.5344 8.63437 57.5344 24.9264C57.5344 41.2184 33.1578 54.7949 33.1578 54.7949Z",
    stroke: "url(#paint0_linear_6582_55687)",
    strokeWidth: 4.02407,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6582_55687",
    x1: 19.2217,
    y1: -7.1139,
    x2: 61.3113,
    y2: 14.8968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.577071,
    stopColor: "#EBBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6EC85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDream3);
export default __webpack_public_path__ + "static/media/icon-dream-3.06be1bdbb5ba074d7cf50aea894e1295.svg";
export { ForwardRef as ReactComponent };